import { useSelector, useDispatch } from "react-redux";
import {DataGrid, gridClasses, GridToolbar} from '@mui/x-data-grid';
/*
import {
    Box,
    Button,
    Divider,
    Icon,
    IconButton,
    List,
    ListItem,
    ListItemText,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
*/

import {
    Box,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemText,
    MenuItem,
    Select,
    TextField
} from "@mui/material";

import { styled } from '@mui/material/styles';
import {stringSortComparator, phoneNumberSortComparator } from "./utilities/string";
import {useEffect, useState} from "react";
import {createCustomer, editCustomerOnDb, getCustomers} from "./actions/customers";
//import {addCustomer, setCustomers, updateCustomer} from "./reducers/customers";
import {addCustomer, setCustomers} from "./reducers/customers";
import {useNavigate, useParams} from "react-router-dom";
import {getCollections} from "./actions/collections";
import {setCollections} from "./reducers/collections";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {getStates} from "./actions/states";
import {setStates} from "./reducers/states";
//import {createAsset} from "./actions/assets";
//import {addAsset} from "./reducers/assets";
import {useCookies} from "react-cookie";
import jwt_decode from "jwt-decode";
import {customerManagementEditorRoles} from "./utilities/roles";


const columns = [
    { field: 'id', headerName: 'ID', width: 100, editable: false },
    { field: 'customer_name', headerName: 'Customer', width: 250, editable: false, },
    { field: 'contact_name', headerName: 'Contact Name', width: 150, editable: false },
    { field: 'phone_number', headerName: 'Phone Number', width: 150, editable: false, sortComparator: phoneNumberSortComparator },
    { field: 'email_address', headerName: 'Email Address', width: 250, editable: false },
    { field: 'Address', headerName: 'Address', width: 650, editable: false, valueGetter: (params) =>
        `${params.row.address1} ${params.row.address2 || ''}${params.row.city}, ${params.row.state != null ? params.row.state.code : ''} ${params.row.zip_code}`,
        sortComparator: stringSortComparator
    },
]

const pageSizeOptions = [20];

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`&`]: { height: '850px' },
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: '#F8F8F8'
    },
    [`& .${gridClasses.row}.Mui-selected`]: {
        backgroundColor: '#006225', // TODO make this match Compucycle branding guidelines,
        color: 'white'
    },
    [`& .${gridClasses.row}.Mui-selected:hover`]: {
        backgroundColor: '#009f3c', // TODO make this match Compucycle branding guidelines,
        color: 'white'
    },
}));

const CustomerManagement = (props = {}) => {
    const navigate = useNavigate();
    const customers = useSelector(state => state.customers.value )
    const states = useSelector(st => st.states.value )
    const auth = useSelector(st => st.auth.value )
    const collections = useSelector(st => st.collections.value );
    //const [cookies, setCookie, removeCookie] = useCookies(['access_token']);
    const [cookies] = useCookies(['access_token']);

    const decoded = jwt_decode(cookies.access_token);
    console.log(JSON.stringify(decoded));
    const canEditCustomers = customerManagementEditorRoles.includes(decoded.user.role);

    const dispatch = useDispatch();
    const { id } = useParams();
    const [ isLoaded, setIsLoaded ] = useState(false);

    const [ selectedCustomer, setSelectedCustomer ] = useState(null);
    const [ cleanCustomer, setCleanCustomer ] = useState(null);

    const [ newCustomer, setNewCustomer ] = useState({});

    const [ dirtyFlag, setDirtyFlag ] = useState(false);

    const [ customersWithRelations, setCustomersWithRelations ] = useState([]);
    const [ showNewCustomerDialog, setShowNewCustomerDialog ] = useState(false);
    const [ creatingCustomer, setCreatingCustomer ] = useState(false);
    const [ updatingCustomer, setUpdatingCustomer ] = useState(false);

    const updateCustomerField = (field, value) => {
        const updatedCustomer = Object.assign({}, selectedCustomer, { [field]: value } );
        setSelectedCustomer(updatedCustomer);
        setDirtyFlag(true);
    }

    const updateNewCustomerField = (field, value) => {
        const updatedCustomer = Object.assign({}, newCustomer, { [field]: value } );
        setNewCustomer(updatedCustomer);
    }

    useEffect(() => {
        const fetchData = () => async (dispatch) => {
            if( states.length === 0 ) {
                const updatedStates = await getStates(auth.token);
                dispatch(setStates(updatedStates.data));
            }
            if( customers.length === 0 ) {
                const updatedCustomers = await getCustomers(auth.token);
                dispatch(setCustomers(updatedCustomers.data));
                const customersWithRels = updatedCustomers.data.map(x => {
                    return Object.assign({}, x, {
                        state: states.find(y => y.id === x.state_id)
                    });
                });
                setCustomersWithRelations(customersWithRels);
            } else {
                const customersWithRels = customers.map(x => {
                    return Object.assign({}, x, {
                        state: states.find(y => y.id === x.state_id)
                    });
                });
                setCustomersWithRelations(customersWithRels);
            }
            if( collections.length === 0 ) {
                const updatedCollections = await getCollections(auth.token);
                dispatch(setCollections(updatedCollections.data));
            }
            setIsLoaded(true);
        }
        dispatch(fetchData());
    }, [dispatch, states, auth, collections,customers]);

    useEffect(() => {
        if( isLoaded ) {
            const customersWithRels = customers.map(x => {
                return Object.assign({}, x, {
                    state: states.find(y => y.id === x.state_id)
                });
            });
            setCustomersWithRelations(customersWithRels);
        }
    }, [customers, isLoaded,states]);

    useEffect(() => {
        if(id != null && id !== '') {
            setSelectedCustomer(customers.find(c => c.id === parseInt(id)));
        }
    }, [isLoaded,customers,id]);

    const rowClickListener = (
        params, // GridRowParams
        event, // MuiEvent<React.MouseEvent<HTMLElement>>
        details, // GridCallbackDetails
    ) => {
        if( selectedCustomer != null ) {
            if( selectedCustomer.id === params.row.id ) {
                setSelectedCustomer(null);
                setCleanCustomer(null);
            } else {
                setSelectedCustomer(params.row);
                setCleanCustomer(params.row);
            }
        } else {
            setSelectedCustomer(params.row);
            setCleanCustomer(params.row);
        }
    };

    return (
        <Box sx={{  height: '100vh', width: '100%' }}>
            <div style={{ paddingTop: 10}}>
                <Button style={{margin: 10}} onClick={() => setShowNewCustomerDialog(true)} variant="contained" color="primary">New Customer</Button>
            </div>
            {selectedCustomer == null ? null : (
                <div style={{ position: "relative"}}>

                <div style={{ "display": "flex", flexDirection: "row", padding: 20}}>
                <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                    <TextField disabled={!canEditCustomers} onChange={(e) => updateCustomerField('customer_name', e.target.value)} style={{marginTop: 10}} id="customer-name" label="Customer Name" variant="outlined" value={selectedCustomer.customer_name} />
                </div>
                <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                    <TextField disabled={!canEditCustomers} onChange={(e) => updateCustomerField('contact_name', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-contact-name" label="Contact Name" variant="outlined" value={selectedCustomer.contact_name} />
                    <TextField disabled={!canEditCustomers} onChange={(e) => updateCustomerField('phone_number', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-contact-phone" label="Contact Phone" variant="outlined" value={selectedCustomer.phone_number} />
                    <TextField disabled={!canEditCustomers} onChange={(e) => updateCustomerField('email_address', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-contact-email" label="Contact Email" variant="outlined" value={selectedCustomer.email_address} />
                </div>
                <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                    <TextField disabled={!canEditCustomers} onChange={(e) => updateCustomerField('address1', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-address1" label="Address" variant="outlined" value={selectedCustomer.address1} />
                    <TextField disabled={!canEditCustomers} onChange={(e) => updateCustomerField('address2', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-address1" label="Address 2" variant="outlined" value={selectedCustomer.address2} />
                    <TextField disabled={!canEditCustomers} onChange={(e) => updateCustomerField('city', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-city" label="City" variant="outlined" value={selectedCustomer.city} />
                    <div style={{marginTop: 10}}>
                        <Select
                            disabled={!canEditCustomers}
                            style={{marginRight: 10}}
                            id="customer-state"
                            value={selectedCustomer.state_id}
                            label="State"
                            onChange={(e) => updateCustomerField('state_id', e.target.value)}
                        >
                            {states.map(st => <MenuItem key={st.id} value={st.id}>{st.name}</MenuItem>)}
                        </Select>
                        <TextField disabled={!canEditCustomers}  onChange={(e) => updateCustomerField('zip_code', e.target.value)} id="customer-zip" style={{width: 150}}  type="number" label="ZIP Code" variant="standard" value={selectedCustomer.zip_code} />
                    </div>
                </div>
                <div style={{ paddingTop: 10, display: "flex", flexDirection: "column"}}>
                    <Button onClick={async () => {
                        setUpdatingCustomer(true);
                        const result = await editCustomerOnDb(auth.token, selectedCustomer);
                        if( result.status === "success") {
                            const customers = await getCustomers(auth.token);
                            dispatch(setCustomers(customers.data));
                            setSelectedCustomer(null);
                            setCleanCustomer(null);
                            setDirtyFlag(false);
                        } else {
                            console.log("Error saving asset: " + JSON.stringify(result.error));
                        }
                        setUpdatingCustomer(false);
                    }} style={{margin: 10}} variant="contained" color="primary" disabled={!dirtyFlag || !canEditCustomers}>Update Customer</Button>
                    <Button onClick={() => { setSelectedCustomer(cleanCustomer); setDirtyFlag(false) }} style={{margin: 10}} variant="contained" color="secondary" disabled={!dirtyFlag}>Discard Changes</Button>
                </div>
                <div style={{display: "flex", fontWeight: "bold", "flexDirection": "column", justifyContent: 'center', alignItems: 'center'}}>
                    <div>Collections</div>
                <Box sx={{ height: 250, overflow: 'auto'}}>
                    <List>
                        {collections.filter(c => c.id === selectedCustomer.id).map((c, i) => {
                            return <ListItem>
                                <ListItemText primary={`${c.lot_number}: ${(c.start_time || "").slice(0,10)} - ${c.end_time ? c.end_time.slice(0,10) : ''}`}/>
                                <IconButton variant="outlined" onClick={() => navigate(`/CollectionReports/${c.id}`)}>
                                    <ArrowForwardIcon/>
                                </IconButton>
                            </ListItem>
                        })}
                    </List>
                </Box>
                </div>

                </div>
                    {updatingCustomer ? (
                        <div style={{position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <div className="lds-roller">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    ) : null }
                </div>
            )}
                <StripedDataGrid
                    slots={{ toolbar: GridToolbar }}
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    rows={customersWithRelations}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 20,
                            },
                        },
                    }}
                    density="compact"
                    pageSizeOptions={pageSizeOptions}
                    onRowClick={rowClickListener}
                />
            {!isLoaded ? (
                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            ) : null}
            {showNewCustomerDialog ? (
                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div style={{display: "flex", flexDirection: "column", background: "white"}}>
                        <div style={{fontSize: 20, fontWeight: "bold", padding: 20, alignSelf: "center", display: "flex"}}>New Customer</div>
                        <div style={{ "display": "flex", flexDirection: "row", paddingLeft: 20, paddingRight: 20, background: "white"}}>
                            <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                                <TextField onChange={(e) => updateNewCustomerField('customer_name', e.target.value)} style={{marginTop: 10}} id="customer-name" label="Customer Name" variant="outlined" value={newCustomer.customer_name} />
                            </div>
                            <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                                <TextField onChange={(e) => updateNewCustomerField('contact_name', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-contact-name" label="Contact Name" variant="outlined" value={newCustomer.contact_name} />
                                <TextField onChange={(e) => updateNewCustomerField('phone_number', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-contact-phone" label="Contact Phone" variant="outlined" value={newCustomer.phone_number} />
                                <TextField onChange={(e) => updateNewCustomerField('email_address', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-contact-email" label="Contact Email" variant="outlined" value={newCustomer.email_address} />
                            </div>
                            <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                                <TextField onChange={(e) => updateNewCustomerField('address1', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-address1" label="Address" variant="outlined" value={newCustomer.address1} />
                                <TextField onChange={(e) => updateNewCustomerField('address2', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-address1" label="Address 2" variant="outlined" value={newCustomer.address2} />
                                <TextField onChange={(e) => updateNewCustomerField('city', e.target.value)} style={{marginTop: 10, width: 250}} id="customer-city" label="City" variant="outlined" value={newCustomer.city} />
                                <div style={{marginTop: 10}}>
                                    <Select
                                        style={{marginRight: 10}}
                                        id="customer-state"
                                        value={newCustomer.state_id}
                                        label="State"
                                        onChange={(e) => updateNewCustomerField('state_id', e.target.value)}
                                    >
                                        {states.map(st => <MenuItem key={st.id} value={st.id}>{st.name}</MenuItem>)}
                                    </Select>
                                    <TextField onChange={(e) => updateNewCustomerField('zip_code', e.target.value)} id="customer-zip" style={{width: 150}}  type="number" label="ZIP Code" variant="standard" value={newCustomer.zip_code} />
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: 20, display: "flex", flexDirection: "row-reverse"}}>
                            <Button style={{margin: 10}} onClick={async () => {
                                setCreatingCustomer(true);
                                const result = await createCustomer(auth.token, newCustomer);
                                if( result.status === "success") {
                                    dispatch(addCustomer(Object.assign({}, newCustomer, {id: result.id})));
                                } else {
                                    console.log("Error saving asset: " + JSON.stringify(result.error));
                                }
                                setCreatingCustomer(false);
                                setShowNewCustomerDialog(false);
                                setNewCustomer({});
                            }} variant="contained" color="primary">Save</Button>
                            <Button style={{margin: 10}} onClick={() => { setShowNewCustomerDialog(false); setNewCustomer({});}} variant="contained" color="secondary">Cancel</Button>
                            {creatingCustomer ? (
                                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <div className="lds-roller">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            ) : null }
                        </div>
                    </div>
                </div>
            ) : null}
        </Box>
    )
}

export default CustomerManagement;
